<script>
    import { onMount } from 'svelte';
    import { goto, url, isActive } from '@roxi/routify';
    // import Icon from 'svelte-awesome';
    // import { bars } from 'svelte-awesome/icons';
    
    let mobile_extended = false;

    const links = [
        ['about-padg', 'ABOUT'],
        ['products', 'PRODUCTS'],
        ['contact', 'CONTACT']
    ];

    function extendMobileNavbar() {
        mobile_extended = !mobile_extended;
        if (mobile_extended) {
            document.getElementById('main-container').parentElement.style.overflowY = 'hidden';
            document.getElementById('main-container').parentElement.style.position = 'fixed';
        } else {
            document.getElementById('main-container').parentElement.style.overflowY = 'auto';
            document.getElementById('main-container').parentElement.style.position = 'unset';
        }
    }
</script>

<!--Hacky method to switch between mobile and desktop
    There's probably a better way to implement in Svelte
    But this method works.
    TODO: FIX INTO SVELTE METHOD RATHER THAN TAILWIND BREAKPOINTS
-->
<div id='navbar'>
    <div class="relative w-full md:hidden mb-5">
        <div class="w-max mx-auto">    
            <a href="/dashboard">
                <div class="w-max p-6 text-center text-2xl font-bold font-mono">
                    <img class="logo h-8" src="./ref/padg_lockup.svg" alt="Palo Alto Data Group Logo">
                </div>
            </a>
        </div>
        <!-- From svelte-awesome; but the library takes too long to compile. -->
        <div class="absolute z-[120] top-5 left-5" on:click={extendMobileNavbar} on:keypress={extendMobileNavbar}>
            <svg version="1.1" class="inline-block" width="27.428571428571427" height="40" role="presentation" viewBox="0 0 1536 1792" style="font-size: 2em; fill:white">
                <path id="path-0" d="M1536 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 832v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 320v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"></path>
            </svg>
            <!-- <Icon data={bars} scale="2"/> -->
        </div>
        {#if mobile_extended}
            <div id="grey-out" class="absolute top-0 left-0 h-screen w-screen opacity-30 bg-black z-[100]"
                on:click={extendMobileNavbar} on:keypress={extendMobileNavbar}>
            </div>
            <div class="absolute top-0 left-0 pt-16 h-screen z-[110] text-white bg-palo-alto-normal">
                <nav class="flex flex-col mt-8 ml-auto">
                    {#each links as [id, name]}
                        <button class="navbutton py-5 border-r-0 h-full w-full"
                            on:click={() => {
                                extendMobileNavbar();
                                document.getElementById(id).scrollIntoView({'behavior': 'smooth'});
                            }}
                        >
                            <div class="w-auto h-full px-8">
                                {name}
                            </div>
                        </button>
                    {/each}
                </nav>
            </div>
        {/if}
    </div>
    <div class="hidden md:flex border-b-2 mt-20 mb-5 mx-[calc(6rem+0.1*(100%-768px))]">
            <a href="/">
                <div class="mb-4 pr-5 text-left text-2xl font-bold font-mono">
                    <img class="logo h-8" src="./ref/padg_lockup.svg" alt="Palo Alto Data Group Logo">
                </div>
            </a>
            <nav id="horizontal-navbar" class="flex items-end space-x-4 ml-auto text-white">
                {#each links as [id, name]}
                <button class="navbutton items-end justify-end" on:click={() => {
                    document.getElementById(id).scrollIntoView({'behavior': 'smooth'});
                }}>
                    {name}
                </button>
                {/each}
            </nav>
        </div>
</div>

<style>
    .navbutton {
        @apply mb-3 px-2 text-xl border-0 rounded-none text-gray-100 w-full font-mono font-medium;
    }
    .navbutton:hover {
        @apply no-underline;
    }
    #horizontal-navbar > a:last-child {
        @apply pr-0;
    }
</style>